import { NotificationType } from "constants/NotificationConstants";
import { Severity } from "constants/Severity";
import { NotificationResource } from "models/Resources/NotificationResource";

export type NotificationResponse = {
  notificationId: string;
  source: string;
  entrepot: number;
  type: string;
  severite: string;
  titre: string;
  texte: string;
  elementId?: string;
  emiseLe: string;
  expireLe?: string;
  luLe?: string;
  luPar?: string;
  deduplication?: string;
};

export function transformNotificationResponseToResource(
  notificationResponse: NotificationResponse
): NotificationResource {
  return {
    notificationId: notificationResponse.notificationId,
    title: notificationResponse.titre,
    type: mapToNotificationType(notificationResponse.type.toLowerCase()),
    severity: mapToNotificationSeverity(notificationResponse.severite),
    text: notificationResponse.texte,
    source: notificationResponse.source,
    elementId: notificationResponse.elementId
      ? notificationResponse.elementId
      : undefined,
    sentDate: new Date(notificationResponse.emiseLe),
    expiryDate: notificationResponse.expireLe
      ? new Date(notificationResponse.expireLe)
      : undefined,
    archivedDate: notificationResponse.luLe
      ? new Date(notificationResponse.luLe)
      : undefined,
    warehouse: notificationResponse.entrepot,
    archivedBy: notificationResponse.luPar
      ? notificationResponse.luPar
      : undefined,
    duplication: notificationResponse.deduplication
      ? notificationResponse.deduplication
      : undefined,
  } as NotificationResource;
}

function mapToNotificationType(type: string): NotificationType {
  switch (type.toLowerCase()) {
    case "urgente":
      return NotificationType.IMPORTANT;
    case "importante":
      return NotificationType.IMPORTANT;
    case "important":
      return NotificationType.IMPORTANT;
    default:
      return NotificationType.NORMAL;
  }
}
function mapToNotificationSeverity(severity: string): Severity {
  switch (severity.toLowerCase()) {
    case "succes":
      return Severity.SUCCESS;
    case "attention":
      return Severity.WARNING;
    case "erreur":
      return Severity.ERROR;
    default:
      return Severity.INFO;
  }
}
